import styled from '@emotion/styled'
import { Text } from '@hhgtech/hhg-components/mantine'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'

export const StyledHomepageBannerWrapper = styled.div`
  ${MediaQueries.mbDown} {
    :not(.only-menu) {
      margin: 0 0 16px 0;
      padding: 24px 0 24px 0;
    }
    background-color: ${theme.colors.primary100};
    background-size: cover;
    background-repeat: no-repeat;
  }
`

export const StyledHomepageContainer = styled.div`
  ${MediaQueries.mbUp} {
    :not(.only-menu) {
      padding: 0;
      min-height: 280px;
    }
    position: relative;
    background-color: ${theme.colors.primary100};
    background-size: cover;
    background-repeat: no-repeat;
  }
  ${MediaQueries.mbDown} {
    &.only-menu {
      padding: 18px 0;
      .menu-wrapper {
        margin-top: 0;
      }
    }
  }
`

export const StyledHomepageImg = styled.div`
  display: flex;
  flex-shrink: 0;
  pointer-events: none;
  user-select: none;
  position: relative;

  ${MediaQueries.mbDown} {
    position: relative;
    max-width: 200px;
    max-height: 200px;
    display: flex;
    width: 40%;
    height: 100%;
    aspect-ratio: 1;
  }

  ${MediaQueries.mbUp} {
    max-width: 280px;
    max-height: 280px;
    width: 100%;
    height: 100%;
    align-self: flex-end;
    flex: 1;
    position: absolute;
    right: 15%;
    bottom: 0;
    object-fit: contain;
    .home-banner-image {
      aspect-ratio: 1;
      object-fit: contain !important;
      object-position: bottom;
    }
  }
`

export const StyledBannerMenu = styled.div`
  ${MediaQueries.mbDown} {
    padding: 0 16px;
  }
`

export const StyledBannerMenuWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin: 0 auto;

  ${MediaQueries.tdUp} {
    max-width: 1170px;
    gap: 16px;
    padding: 16px;
    margin: 8px auto;
  }

  ${MediaQueries.tdOnly} {
    gap: 16px;
  }
`

export const StyledMenuCard = styled.a`
  display: flex;
  padding: 16px 3px 0;

  /* System/z1 (small) */

  border-radius: 4px;
  text-decoration: none;

  ${MediaQueries.mbUp} {
    align-items: center;
    gap: 16px;
    flex: 1;
    padding: 16px;
    background: ${theme.colors.neutral50};
  }

  ${MediaQueries.mbDown} {
    display: flex;
    flex: 1 1 0px;
    align-items: center;
    flex-direction: column;
    gap: 9px;
  }
  [data-size='p3'] {
    line-height: 24px;
  }
  &[data-two-column='true'] {
    ${MediaQueries.mbDown} {
      grid-column-start: 1;
      grid-column-end: 3;
      justify-content: center;
    }
  }
`

export const StyledMenuIcon = styled.img`
  display: block;
  width: 32px;
  height: 32px;

  ${MediaQueries.mbUp} {
    width: 40px;
    height: 40px;
  }
`

export const StyledMenuText = styled(Text)`
  ${MediaQueries.mbDown} {
    text-align: center;
  }
  ${MediaQueries.mbUp} {
    display: -webkit-box;

    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
  }
`

export const StyledMenuDivider = styled.hr`
  border: none;
  border-top: 2px dashed ${theme.colors.neutral100};

  ${MediaQueries.mbDown} {
    margin: 16px -16px;
  }
  ${MediaQueries.mbUp} {
    max-width: 1138px;
    margin: 0 auto;
    padding: 0 16px;
  }
`
